import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getAccessToken } from '@sxm-de/dev-kits/web-sdk/utils';

export async function claimTrial(
    {
        vehicleDeviceId,
        oemDriverId,
    }: {
        vehicleDeviceId: string;
        oemDriverId?: string;
    },
    { atlasSdk, appEventSdk }: DependenciesPayload,
) {
    try {
        await atlasSdk.domains.user.claimTrial({
            request: {
                vehicleDeviceId,
                ...(oemDriverId
                    ? { oemDriverId, useExistingOEMProfile: false }
                    : { useExistingOEMProfile: true }),
            },
            accessToken: getAccessToken(),
        });
        appEventSdk.trackEvent({
            event: 'customer-info',
            data: {
                customerType: 'SXIR_TRIAL',
            },
        });
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
